import { Component } from '@angular/core';
import { NavParams, NavController } from 'ionic-angular';

import { Account } from '../../model/account';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'page-notifications',
    templateUrl: 'notifications.html'
})
export class NotificationsPage {
    account: Account;

    popoverActive: boolean;

    constructor(navParams : NavParams, private nav: NavController, private userService: UserService) {
        this.account = navParams.get("account");
    }

    ionViewWillEnter() {
        this.userService.markNotificationsRead(this.account.id);
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts